import { FormValues } from 'components/SetPasswordForm/types';
import { Nullable } from 'utils/types';

export interface ForgotFormData {
  email: Nullable<string>;
}

export interface ForgotFormProps {
  handleSubmitForm: (values: ForgotFormData) => void;
  isSubmitted: boolean;
  newUi: boolean;
}

export type ResetFormData = FormValues;

export interface ResetFormProps {
  handleSubmit: (values: ResetFormData) => void;
  error: string;
  submitted: boolean;
}
export enum FIELD {
  EMAIL = 'email',
}

export enum FIELD_LABEL {
  EMAIL = 'Email address',
}
